import { yupResolver } from "@hookform/resolvers/yup";
import {
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import PropTypes from "prop-types";
import Snackbar from "@material-ui/core/Snackbar";
import { makeStyles } from "@material-ui/core/styles";
import { Add } from "@material-ui/icons";
import MuiAlert from "@material-ui/lab/Alert";
import { InputLabel } from "components/BulkUpload";
import LoaderView from "components/LoaderView";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getActivityGroups, getJobFamilies } from "redux/actions/appActions";
import { saveBulkEntries } from "services/bulkUpload";
import DropDowns from "./DropDowns";
import PunchRow from "./PunchRow";
import { deepEqual, getTotals } from "./utils";
import { getValidationSchema } from "./validators";
import { ALL_ACTIVITIES, MANAGE_TIMESHEET } from "navigation/CONSTANTS";
import { useHistory, useLocation } from "react-router-dom";
const Alert = (props) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const useStyles = makeStyles((theme) => ({
  table: {
    // minWidth: 650,
  },
  root: {
    flexGrow: 1,
    margin: theme.spacing(3),
  },
  stickHeader: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "white",
  },
  stickFooter: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "white",
  },
  headerRow: {
    backgroundColor: theme.palette.primary.main,
  },
  footerRow: {
    backgroundColor: theme.palette.primary.main,
  },
}));

const days = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
].map((e) => e.toUpperCase());

const recordFormat = {
  family: "",
  group: "",
  projectDetails: "",
  details: "",
  freeForm: "",
  day1: 0,
  day2: 0,
  day3: 0,
  day4: 0,
  day5: 0,
  day6: 0,
  day7: 0,
  showFreeForm: false,
};

const initialRecord = Array.from(Array(1)).map(() => ({ ...recordFormat }));
const initialTotals = Array.from(Array(7)).map(() => ({ hours: 0 }));
const initialTotalsObj = {};
for (let i = 0; i < initialTotals.length; ++i) {
  initialTotalsObj[`day${i + 1}`] = initialTotals[i];
}

export default function BulkUploadPage(props) {
  const location = useLocation();
  const locationProps = location.state;

  const history = useHistory();
  const classes = useStyles();
  const {
    register,
    control,
    handleSubmit,
    reset,
    getValues,
    setValue,
    errors,
    trigger,
    setError,
    clearErrors,
    formState,
  } = useForm({
    defaultValues: { records: initialRecord, weekTotal: initialTotalsObj },
    resolver: yupResolver(getValidationSchema()),
    //mode: "onChange",
  });

  useEffect(() => {
    if (locationProps && locationProps.worker) {
      setValue("selectedWorker", locationProps.worker);
    }
  }, [locationProps]);

  // const formReset = reset();
  const { isValid, isSubmitting, isDirty } = formState;

  const { user } = useSelector((state) => state.user.auth);

  const { t } = useTranslation();

  const [oldData, setOldData] = useState(null);

  const { fields, append } = useFieldArray({
    control,
    name: "records",
  });
  const [loading, setLoading] = useState(true);
  const [saveAllowed, setSaveAllowed] = useState(false);
  const [selectedFieldDropdowns, setSelectedFieldDropdowns] = useState([]);
  const [open, setOpen] = useState(false);
  const [totalHours, setTotalHours] = useState(0);
  const [workerSchedule, setWorkerShedule] = useState({});

  const translatedDays = days
    .map((item) => {
      switch (item) {
        case "SUNDAY":
          return (item = t("other.dscLblSunday"));
        case "MONDAY":
          return (item = t("other.dscLblMonday"));
        case "TUESDAY":
          return (item = t("other.dscLblTuesday"));
        case "WEDNESDAY":
          return (item = t("other.dscLblWednesday"));
        case "THURSDAY":
          return (item = t("other.dscLblThursday"));
        case "FRIDAY":
          return (item = t("other.dscLblFriday"));
        case "SATURDAY":
          return (item = t("other.dscLblSaturday"));
        default:
          item = "new";
      }
    })
    .map((e) => e.toUpperCase());

  const gotoReview = () => {
    //As per the calendar UI features, this older one has to be retained, so on click of cancel it should navigate to Manage Timesheets view
    // history.push(ALL_ACTIVITIES, { isAllPunchView: true });
    history.push(MANAGE_TIMESHEET, { isTimesheetView: true });
  };

  const handleSelectionChange = (selections) => {
    setSelectedFieldDropdowns(selections);
  };

  const handleDropdownCancel = () => {
    //reset();
  };

  const dispatch = useDispatch();

  const handleAdd = () => {
    append(initialRecord);
  };

  const handleDelete = () => {};

  const handleSubmitAction = (data) => {
    const actionTS = new Date().toISOString();
    let dataToSubmit = {
      ...data,
      // districtId: selectedFieldDropdowns.district,
      // buildingId: selectedFieldDropdowns.building,
      // weekStartDate: selectedFieldDropdowns.weekStart,
      // weekEndDate: selectedFieldDropdowns.weekEnd,
      actionBy: user.workerId,
      //actionTs:moment().format(),
      actionTS: actionTS,
      selectedWorker: selectedFieldDropdowns.selectedWorker,
      customerSite: data.customerSite || "",
      workerSchedule
    };
    console.log("Data to Submit", dataToSubmit);
    // saveBulkUploadData(dataToSubmit);
    setLoading(true);
    saveBulkEntries(dataToSubmit)
      .then(() => {
        let { actionBy, actionTS, ...rest } = dataToSubmit;
        setLoading(false);
        setOpen(true);
        setOldData(rest);
        setSaveAllowed(false);
        reset({
          records: initialRecord,
          customerSite: dataToSubmit.customerSite,
        });
      })
      .catch((e) => {
        setLoading(false);
        console.error(e);
      });
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  useEffect(() => {
    dispatch(getActivityGroups());
    dispatch(getJobFamilies());
    setOldData({ records: initialRecord, weekTotal: initialTotalsObj });
  }, []);

  const checkAllValid = (totalHours, selectedFieldDropdowns) => {
    let allowed = false;
    if (totalHours > 0.0) allowed = true;
    if (selectedFieldDropdowns) {
      if (!selectedFieldDropdowns.district) allowed = false;
      if (!selectedFieldDropdowns.building) allowed = false;
      if (!selectedFieldDropdowns.weekStart) allowed = false;
      if (!selectedFieldDropdowns.weekEnd) allowed = false;
    } else allowed = false;
    return allowed;
  };

  // useEffect(() => {
  //   let allowed = false;
  //   if (selectedFieldDropdowns) {
  //     if (!selectedFieldDropdowns.district) allowed = false;
  //     if (!selectedFieldDropdowns.building) allowed = false;
  //     if (!selectedFieldDropdowns.weekStart) allowed = false;
  //     if (!selectedFieldDropdowns.weekEnd) allowed = false;
  //   } else allowed = false;
  //   // if(totalHours > 0) allowed = true;
  //   // else allowed = false;
  //   setSaveAllowed(allowed);
  // }, [selectedFieldDropdowns]);

  return (
    <div className={classes.root}>
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "center", horizontal: "center" }}
      >
        <Alert severity="success" onClose={handleClose}>
          {t("other.timeSheetSuccessMsg")}
        </Alert>
      </Snackbar>
      <LoaderView loading={loading}>
        <form noValidate onSubmit={handleSubmit(handleSubmitAction)}>
          <DropDowns
            {...{
              control,
              register,
              reset,
              setValue,
              getValues,
              trigger,
              errors,
              setError,
              clearErrors,
              disabled: false,
              locationProps,
            }}
            onChangeSelections={handleSelectionChange}
            onDropdownCancel={handleDropdownCancel}
            setWorkerShedule={setWorkerShedule}
            loading={loading}
            setLoading={setLoading}
            onUpdate={() => {
              const values = getValues();
              const records = values.records;
              const cTotals = getTotals(records);
              const { totals } = cTotals;
              setValue("weekTotal", totals);
              setTotalHours(cTotals.totalHours);
              let valid1 = true;
              let valid2 = true;
              let oldSelectedDropdownObj = {
                weekStart: oldData.weekStartDate,
                weekEnd: oldData.weekEndDate,
                selectedWorker: values.selectedWorker,
                district: oldData.districtId,
                building: oldData.buildingId,
              };
              if (oldData) {
                // valid1 = !deepEqual(
                //   oldData.records,
                //   records
                // )
                valid2 = !deepEqual(oldData, values);
              }
              // console.log(oldSelectedDropdownObj, "oldSelectedDropdownObj");
              // console.log(selectedFieldDropdowns, "oldSelectedDropdownObj");
              // console.log(oldData, "oldSelectedDropdownObj");
              // console.log(values, "oldSelectedDropdownObj");

              // let valid3 = checkAllValid(cTotals.totalHours, selectedFieldDropdowns);
              let valid3 = cTotals.totalHours > 0;
              setSaveAllowed(valid2 && valid3);
            }}
          />

          <TableContainer component={Paper}>
            <Table aria-label="punches table" size="small" padding="default">
              <TableHead>
                <TableRow className={classes.headerRow}>
                  <TableCell align="left">
                    <Typography
                      className={classes.stickHeader}
                      variant="body1"
                      component="h6"
                    >
                      &nbsp;&nbsp;{t("other.timeSheetJobFamily")}
                    </Typography>
                  </TableCell>
                  <TableCell align="left">
                    <Typography
                      className={classes.stickHeader}
                      variant="body1"
                      component="h6"
                    >
                      &nbsp;&nbsp;{t("other.timeSheetActivityGroup")}
                    </Typography>
                  </TableCell>
                  <TableCell align="left">
                    <Typography
                      className={classes.stickHeader}
                      variant="body1"
                      component="h6"
                    >
                      &nbsp;&nbsp;{t("other.lblProjectDetails")}
                    </Typography>
                  </TableCell>
                  <TableCell align="left">
                    <Typography
                      className={classes.stickHeader}
                      variant="body1"
                      component="h6"
                    >
                      &nbsp;{t("other.timeSheetDetails")}
                    </Typography>
                  </TableCell>
                  {translatedDays.map((day, dayIndex) => (
                    <TableCell align="center" key={`col_${dayIndex}`}>
                      <Typography
                        className={classes.stickHeader}
                        variant="body1"
                        component="h6"
                      >
                        {day}
                      </Typography>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {fields.map((record, index) => (
                  <PunchRow
                    {...{
                      control,
                      record,
                      index,
                      register,
                      reset,
                      setValue,
                      getValues,
                      trigger,
                      errors,
                      setError,
                      clearErrors,
                      disabled: false,
                      dropdowns: selectedFieldDropdowns,
                    }}
                    key={record.id}
                    onDelete={handleDelete}
                    onUpdate={(row, dayIdx) => {
                      const records = getValues().records;
                      const cTotals = getTotals(records);
                      const { totals } = cTotals;
                      setValue("weekTotal", totals);
                      setTotalHours(cTotals.totalHours);
                      let valid1 = true;
                      if (oldData) {
                        valid1 = !deepEqual(oldData.records, records);
                      }
                      let valid2 = checkAllValid(
                        cTotals.totalHours,
                        selectedFieldDropdowns
                      );

                      setSaveAllowed(valid1 && valid2);
                      if (dayIdx !== -1) {
                        trigger(`records[${row}].group`);
                        trigger(`records[${row}].family`);
                        trigger(`records[${row}].projectDetails`);
                        trigger(`records[${row}].details`);
                        let value = totals[`day${dayIdx}`].hours;
                        value = value ? parseFloat(value) : 0;
                        if (value > 24) {
                          setError(`records[${row}].day${dayIdx}`, {
                            type: "manual",
                            message: "Total exceeded 24 hours",
                          });
                        } else {
                          //
                          for (let i = 0; i < fields.length; ++i) {
                            clearErrors(`records[${i}].day${dayIdx}`);
                          }
                        }
                      } else if (totalHours > 0){
                        trigger(`records[${row}].family`);
                        trigger(`records[${row}].group`);
                      }
                       
                    }}
                  />
                ))}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TableCell colSpan={10}>
                    <Button onClick={handleAdd} color="secondary">
                      <Add /> {t("other.timeSheetAdd")}
                    </Button>
                  </TableCell>
                </TableRow>
                <TableRow className={classes.footerRow}>
                  <TableCell align="left" colSpan={4}>
                    <Typography
                      className={classes.stickFooter}
                      variant="body1"
                      component="h6"
                    >
                      {t("other.timeSheetTotals")}
                    </Typography>
                  </TableCell>
                  {days.map((day, dayIndex) => (
                    <TableCell align="center" key={`total_${dayIndex}`}>
                      <InputLabel
                        fullWidth
                        readOnly
                        margin="dense"
                        inputRef={register()}
                        name={`weekTotal.day${dayIndex + 1}.hours`}
                        defaultValue={"0"}
                        inputProps={{
                          style: { color: "white" },
                        }}
                      />
                    </TableCell>
                  ))}
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
          <Grid container justify="space-between" style={{ marginTop: 24 }}>
            <Grid item>
              <Button
                onClick={() => {
                  reset({
                    ...getValues(),
                    records: initialRecord,
                    weekTotal: initialTotalsObj,
                  });
                  setSaveAllowed(false);
                }}
                color="secondary"
                disabled={!isDirty || isSubmitting}
              >
                {t("other.timeSheetClear")}
              </Button>
            </Grid>
            <Grid item>
              <Grid container justify="space-between" spacing={2}>
                <Grid item>
                  <Button
                    color="primary"
                    variant="outlined"
                    onClick={gotoReview}
                  >
                    {t("general.cancelBtn")}
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    color="primary"
                    variant="contained"
                    type="submit"
                    disabled={!isValid || isSubmitting || !saveAllowed}
                  >
                    {t("other.timeSheetSave")}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </LoaderView>
    </div>
  );
}
BulkUploadPage.propTypes = {
  worker: PropTypes.object,
};
